import axios from "axios";
import store from "@/store";
import router from "@/router";

import { setTokenInLocalStorage } from "@/utils/oauth";

function isExpiredToken(errorData) {
  let errorDescription = errorData.error_description;
  return errorDescription.substring(0, 20) === "Access token expired";
}

const deleteAccessTokenInHeader = () => {
  axios.defaults.headers.common.Authorization = null;
};

const requestRefreshToken = () => {
  const type = localStorage.getItem("access_type");
  let form = new FormData();
  form.append("grant_type", "refresh_token");
  form.append("refresh_token", localStorage.getItem("refresh_token"));
  form.append("type", localStorage.getItem("access_type"));

  switch (type) {
    case "director":
      form.append("userId", localStorage.getItem("directorUserId"));
      break;

    case "corp":
      form.append("userId", localStorage.getItem("corpUserId"));
      break;

    case "funeral":
      form.append("userId", localStorage.getItem("funeralUserId"));
      break;

    default:
      break;
  }

  const requestData = {
    url: `${process.env.VUE_APP_APIURL}/oauth/refresh`,
    method: "POST",
    auth: {
      username: process.env.VUE_APP_CLIENTID,
      password: process.env.VUE_APP_CLIENTSECRET
    },
    data: form
  };
  return axios(requestData);
};

function attemptRefreshToken() {
  return requestRefreshToken()
    .then(res => {
      setTokenInLocalStorage(res.data);
      location.reload();
    })
    .catch(() => {
      store.commit("LOGOUT_WITH_TOKEN_INVALIDE");
    });
}

/*
    모든 요청 전 header에 access_token을 담아 전송한다.
 */
axios.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      config.headers.Authorization = accessToken;
    }

    if (
      accessToken != null &&
      accessToken != undefined &&
      (config.headers.Authorization === null ||
        config.headers.Authorization === undefined) &&
      config.url.indexOf("code-AllList") === -1
    ) {
      config.headers.Authorization = accessToken;
    }

    if (
      config.data !== null &&
      config.data !== undefined &&
      config.data !== undefined &&
      config.data !== "" &&
      config.data.page !== null &&
      config.data.page !== undefined &&
      config.data !== ""
    ) {
      const pageSet = config.url.indexOf("?") > -1 ? "&page=" : "?page=";
      config.url =
        config.url +
        pageSet +
        config.data.page.page +
        "&size=" +
        config.data.page.size +
        "&sort=" +
        config.data.page.sort;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/*
    만료된 access_token으로 요청시 Access token exprited가 발생하면 refresh 토큰으로 새로운 토큰을 받는다.
 */
axios.interceptors.response.use(
  response => {
    if (response.data === 1) {
      attemptRefreshToken();
    }
    if (response.data === 2) {
      // console.log(response.data);
    }

    return response;
  },
  function(error) {
    if (!error.response) {
      router.push("/error");
    }
    let status = error.response.status;
    if (status === 500) {
      store.commit("PUSH_ERROR_PAGE");
      return Promise.reject(error);
    }
    if (status === 401) {
      let errorData = error.response.data;
      if (errorData.error !== "invalid_token") {
        return Promise.reject(error);
      }
      if (isExpiredToken(errorData)) {
        attemptRefreshToken();
        return Promise.reject(new Error("refresh"));
      } else {
        store.commit("LOGOUT_WITH_TOKEN_INVALIDE");
      }
    }
    return Promise.reject(error);
  }
);

function requestEncode(parameter) {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/certify/encoding?str=${parameter}`
  );
}

const requestMain = param => {
  return axios.post(`${process.env.VUE_APP_APIURL}/api/app/main`, param);
};

const requestDirectorMain = () => {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/app/director/main`);
};

const requestDirectorObituary = () => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/director/reg-obituary-data`
  );
};
const requestFuneralObituary = () => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/funeral/reg-obituary-data`
  );
};

export {
  deleteAccessTokenInHeader,
  requestEncode,
  //
  requestMain,
  requestDirectorMain,
  requestDirectorObituary,
  requestFuneralObituary
};
